
























































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { titlePages } from '@/api/api.config'
import html2canvas from 'html2canvas'
@Component
export default class Sgs extends Vue {
  orederIds: any = ''
  list: any = {}
  list1: any = {}
  list2: any = {}
  list3: any = {}
  res: any = []
  souh: any = 0
  Overlay = false
  size = 300
  sizes = 300
  sizees = 300
  project: any = {}
  canvasImageUrl: any = ''
  isDom: any = true
  Charts(res: any) {
    var chartDom = document.getElementById('main')
    var myChart = (this as any).$echarts.init(chartDom)
    let ssadas = res.data.data.partyItems
    let arr = []
    arr.push(
      ssadas.bmsTotalCurrentPrecision,
      ssadas.bmsTotalVoltageOverrun,
      ssadas.bmsTotalVoltagePrecision,
      ssadas.socDeviation,
      ssadas.sohAttenuation,
      ssadas.batAlarmScore,
    )
    var option
    option = {
      title: {
        text: '',
      },
      textStyle: {
        // color: "#5EACCC",
        // textShadowColor: "#aaa",
        // textShadowBlur: 3,
        // textShadowOffsetY: 2,
        fontSize: 9,
        rich: {},
      },

      tooltip: {
        trigger: 'axis',
      },
      legend: {
        center: 'center',
        data: [''],
      },
      radar: [
        {
          indicator: [
            { text: 'BMS总电流测量精度' },
            { text: 'BMS总电压测量精度' },
            { text: 'BMS总电压超限' },
            { text: 'SOC估计误差' },
            { text: 'SOH衰减诊断' },
            { text: '电池警告总分' },
          ],
          center: ['50%', '50%'],
          radius: 50,
        },
      ],
      series: [
        {
          type: 'radar',
          areaStyle: {
            color: '#d1e9ff',
          },
          data: [
            {
              value: [...arr],
              // color: ['#F081BC','#84B7DD'],
              label: {
                // show: true,
                // formatter: function (params) {
                //   return params.value;
                // },
              },

              name: ' ',
            },
          ],
        },
      ],
    }
    option && myChart.setOption(option)
  }
  // SOC
  Polyline(res: any) {
    var chartDom = document.getElementById('mains')
    var myChart = (this as any).$echarts.init(chartDom)
    let maxs = res.data.data.currentMeasures
    let socs = res.data.data.socs
    var max = 1,
      min = 10
    var max1 = Math.max.apply(null, maxs)
    var min1 = Math.min.apply(null, maxs)
    var max2 = Math.max.apply(null, socs)
    var min2 = Math.min.apply(null, socs)
    if (max1 >= max2) {
      max = max1
    } else {
      max = max2
    }
    if (min1 >= min2) {
      min = min2
    } else {
      min = min1
    }
    var option
    option = {
      dataZoom: [
        {
          type: 'inside',
          zoomLock: true,
          startValue: 0,
          endValue: 12,
        },
      ],
      title: {
        text: '',
      },
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        textStyle: {
          fontSize: 12,
        },
      },

      toolbox: {
        show: false,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          dataView: { readOnly: false },
          magicType: { type: ['line', 'bar'] },
          restore: {},
          saveAsImage: {},
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        position: 'left',
        data: [...res.data.data.value],
        axisLabel: {
          padding: [0, 10], //文字左右定位
          interval: 11,
          formatter: function (params: any) {
            var newParamsName = '' // 最终拼接成的字符串
            var paramsNameNumber = params.length // 实际标签的个数
            var provideNumber = 9 // 每行能显示的字的个数
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
            /**
             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
             */
            // 条件等同于rowNumber>1
            if (paramsNameNumber > provideNumber) {
              /** 循环每一行,p表示行 */
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = '' // 表示每一次截取的字符串
                var start = p * provideNumber // 开始截取的位置
                var end = start + provideNumber // 结束截取的位置
                // 此处特殊处理最后一行的索引值
                if (p == rowNumber - 1) {
                  // 最后一次不换行
                  tempStr = params.substring(start, paramsNameNumber)
                } else {
                  // 每一次拼接字符串并换行
                  tempStr = params.substring(start, end) + '\n'
                }
                newParamsName += tempStr // 最终拼成的字符串
              }
            } else {
              // 将旧标签的值赋给新标签
              newParamsName = params
            }
            //将最终的字符串返回
            return newParamsName
          },
        },
      },
      yAxis: {
        type: 'value',
        min: min - 5,
        max: max + 5,
        // nameGap: 35,
        // splitNumber : 10,
        axisLabel: {
          formatter: '{value} ',
          textStyle: {
            fontSize: 10,
            // color: "#FFFFFF",
          },
        },
      },
      series: [
        {
          name: '车辆总电流',
          type: 'line',
          data: [...res.data.data.currentMeasures],
          itemStyle: {
            normal: {
              color: '#5fbdff', //折线点上的颜色
              lineStyle: {
                color: '#5fbdff', //折线上颜色
              },
            },
          },
          markPoint: {
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  color: '#ffffff',
                },
              },
            },
            data: [
              { type: 'max', name: 'Max' },
              // { type: "min", name: "Min" },
            ],
          },
          // markLine: {
          //   data: [{ type: 'average', name: 'Avg' }]
          // }
        },
        {
          name: '车辆SOC',
          type: 'line',
          data: [...res.data.data.socs],
          itemStyle: {
            normal: {
              color: '#89c7a8', //折线点上的颜色
              lineStyle: {
                color: '#89c7a8', //折线上颜色
              },
            },
          },
          markPoint: {
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  color: '#ffffff',
                },
              },
            },
            data: [
              { type: 'max', name: 'Max' },
              // { type: "min", name: "Min" },
            ],
          },
        },
      ],
    }

    option && myChart.setOption(option)
  }
  voltage(res: any) {
    var chartDom = document.getElementById('line')
    var myChart = (this as any).$echarts.init(chartDom)
    let maxs = res.data.data.voltMeasures
    let max = Math.max.apply(null, maxs)
    let min = Math.min.apply(null, maxs)
    console.log(min, '最小值')
    var option
    option = {
      dataZoom: [
        {
          type: 'inside',
          zoomLock: true,
          startValue: 0,
          endValue: 12,
        },
      ],
      title: {
        text: '车端总电压',
        left: 'center',
        top: '20px',
      },
      xAxis: {
        type: 'category',
        data: [...res.data.data.value],
        splitLine: {
          show: true,
        },
        axisLabel: {
          interval: 11,
          textStyle: {
            // color: "##a0cef1",
            // fontSize: 14,
          },
          formatter: function (params: any) {
            var newParamsName = '' // 最终拼接成的字符串
            var paramsNameNumber = params.length // 实际标签的个数
            var provideNumber = 10 // 每行能显示的字的个数
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
            /**
             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
             */
            // 条件等同于rowNumber>1
            if (paramsNameNumber > provideNumber) {
              /** 循环每一行,p表示行 */
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = '' // 表示每一次截取的字符串
                var start = p * provideNumber // 开始截取的位置
                var end = start + provideNumber // 结束截取的位置
                // 此处特殊处理最后一行的索引值
                if (p == rowNumber - 1) {
                  // 最后一次不换行
                  tempStr = params.substring(start, paramsNameNumber)
                } else {
                  // 每一次拼接字符串并换行
                  tempStr = params.substring(start, end) + '\n'
                }
                newParamsName += tempStr // 最终拼成的字符串
              }
            } else {
              // 将旧标签的值赋给新标签
              newParamsName = params
            }
            //将最终的字符串返回
            return newParamsName
          },
        },

        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        name: '电压 (V)',
        min: min - 10,
        max: max + 20,
        position: 'left',
        alignTicks: true,
        nameTextStyle: {
          color: '#464646',
          // fontSize: 12,
        },
        // axisLabel: {
        //   formatter: "{value} °C",
        // },
      },
      series: [
        {
          data: [...res.data.data.voltMeasures],
          markPoint: {
            data: [
              {
                type: max, //最大值
              },
              {
                type: min, //最小值
              },
            ],
          },
          type: 'line',
          lineStyle: {
            width: 1,
            type: '',
          },
          itemStyle: {
            normal: {
              color: '#64bfff', //改变折线点的颜色
              lineStyle: {
                color: '#64bfff', //改变折线颜色
              },
            },
          },
        },
      ],
    }

    option && myChart.setOption(option)
  }
  ceilingVoltage(res: any) {
    var chartDom = document.getElementById('lines')
    var myChart = (this as any).$echarts.init(chartDom)
    let maxs = res.data.data.maxSingleVolt
    let max = Math.max.apply(null, maxs)
    max = Math.round(max)
    let min = Math.min.apply(null, maxs)
    min = Math.round(min)
    var option
    option = {
      dataZoom: [
        {
          type: 'inside',
          zoomLock: true,
          startValue: 0,
          endValue: 12,
        },
      ],
      title: {
        text: '单体最高电压',
        left: 'center',
        top: '20px',
      },
      xAxis: {
        type: 'category',
        data: [...res.data.data.value],
        splitLine: {
          show: true,
        },
        axisLabel: {
          interval: 11,
          textStyle: {
            // color: "##a0cef1",
            // fontSize: 14,
          },
          formatter: function (params: any) {
            var newParamsName = '' // 最终拼接成的字符串
            var paramsNameNumber = params.length // 实际标签的个数
            var provideNumber = 10 // 每行能显示的字的个数
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
            /**
             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
             */
            // 条件等同于rowNumber>1
            if (paramsNameNumber > provideNumber) {
              /** 循环每一行,p表示行 */
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = '' // 表示每一次截取的字符串
                var start = p * provideNumber // 开始截取的位置
                var end = start + provideNumber // 结束截取的位置
                // 此处特殊处理最后一行的索引值
                if (p == rowNumber - 1) {
                  // 最后一次不换行
                  tempStr = params.substring(start, paramsNameNumber)
                } else {
                  // 每一次拼接字符串并换行
                  tempStr = params.substring(start, end) + '\n'
                }
                newParamsName += tempStr // 最终拼成的字符串
              }
            } else {
              // 将旧标签的值赋给新标签
              newParamsName = params
            }
            //将最终的字符串返回
            return newParamsName
          },
        },

        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        name: '电压 (V)',
        min: min - 0.5,
        max: max + 0.5,
        splitNumber: 0,
        position: 'left',
        alignTicks: true,
        nameTextStyle: {
          color: '#464646',
          // fontSize: 12,
        },
        // axisLabel: {
        //   formatter: "{value} °C",
        // },
      },
      series: [
        {
          name: '电压',
          data: [...res.data.data.maxSingleVolt],
          markPoint: {
            data: [
              {
                type: 10, //最大值
              },
              {
                type: 1, //最小值
              },
            ],
          },
          type: 'line',
          lineStyle: {
            width: 1,
            type: '',
          },
          itemStyle: {
            normal: {
              color: '#64bfff', //改变折线点的颜色
              lineStyle: {
                color: '#64bfff', //改变折线颜色
              },
            },
          },
        },
      ],
    }

    option && myChart.setOption(option)
  }
  monomerTemperature(res: any) {
    var chartDom = document.getElementById('temperature')
    var myChart = (this as any).$echarts.init(chartDom)
    let maxs = res.data.data.maxMin
    let max = Math.max.apply(null, maxs)
    let min = Math.min.apply(null, maxs)
    var option
    option = {
      dataZoom: [
        {
          type: 'inside',
          zoomLock: true,
          startValue: 0,
          endValue: 12,
        },
      ],
      title: {
        text: '温度极差',
        left: 'center',
        top: '20px',
      },
      xAxis: {
        type: 'category',
        data: [...res.data.data.value],
        splitLine: {
          show: true,
        },
        axisLabel: {
          interval: 11,
          textStyle: {
            // color: "##a0cef1",
            // fontSize: 14,
          },
          // interval: 0,
          formatter: function (params: any) {
            var newParamsName = '' // 最终拼接成的字符串
            var paramsNameNumber = params.length // 实际标签的个数
            var provideNumber = 10 // 每行能显示的字的个数
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
            /**
             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
             */
            // 条件等同于rowNumber>1
            if (paramsNameNumber > provideNumber) {
              /** 循环每一行,p表示行 */
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = '' // 表示每一次截取的字符串
                var start = p * provideNumber // 开始截取的位置
                var end = start + provideNumber // 结束截取的位置
                // 此处特殊处理最后一行的索引值
                if (p == rowNumber - 1) {
                  // 最后一次不换行
                  tempStr = params.substring(start, paramsNameNumber)
                } else {
                  // 每一次拼接字符串并换行
                  tempStr = params.substring(start, end) + '\n'
                }
                newParamsName += tempStr // 最终拼成的字符串
              }
            } else {
              // 将旧标签的值赋给新标签
              newParamsName = params
            }
            //将最终的字符串返回
            return newParamsName
          },
        },

        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        name: '单体温度极差 (°C)',
        min: min - 5 < 0 ? 0 : min - 5,
        max: max + 5,
        position: 'left',
        alignTicks: true,
        nameTextStyle: {
          color: '#464646',
          padding: [0, 0, 0, 35], // 四个数字分别为上右下左与原位置距离
          // fontSize: 12,
        },
        // axisLabel: {
        //   formatter: "{value} °C",
        // },
      },
      series: [
        {
          data: [...res.data.data.maxMin],
          type: 'line',
          lineStyle: {
            width: 1,
            type: '',
          },
          itemStyle: {
            normal: {
              color: '#64bfff', //改变折线点的颜色
              lineStyle: {
                color: '#64bfff', //改变折线颜色
              },
            },
          },
        },
      ],
    }

    option && myChart.setOption(option)
  }
  rangetemperature(res: any) {
    var chartDom = document.getElementById('rangetemperature')
    var myChart = (this as any).$echarts.init(chartDom)
    let maxs = res.data.data.maxTemp
    let minx = res.data.data.minTemp
    var max1 = Math.max.apply(null, maxs)
    var min1 = Math.min.apply(null, maxs)
    var max2 = Math.max.apply(null, minx)
    var min2 = Math.min.apply(null, minx)
    let max = 1,
      min = 10
    if (max1 >= max2) {
      max = max1
    } else {
      max = max2
    }
    if (min1 >= min2) {
      min = min2
    } else {
      min = min1
    }
    var option
    option = {
      dataZoom: [
        {
          type: 'inside',
          zoomLock: true,
          startValue: 0,
          endValue: 12,
        },
      ],
      title: {
        text: '极值温度',
        left: 'center',
        top: '20px',
      },
      xAxis: {
        type: 'category',
        data: [...res.data.data.value],
        splitLine: {
          show: true,
        },
        axisLabel: {
          interval: 11,
          textStyle: {
            // color: "##a0cef1",
            // fontSize: 14,
          },
          // interval: 5 ,

          formatter: function (params: any) {
            var newParamsName = '' // 最终拼接成的字符串
            var paramsNameNumber = params.length // 实际标签的个数
            var provideNumber = 10 // 每行能显示的字的个数
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber) // 换行的话，需要显示几行，向上取整
            /**
             * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
             */
            // 条件等同于rowNumber>1
            if (paramsNameNumber > provideNumber) {
              /** 循环每一行,p表示行 */
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = '' // 表示每一次截取的字符串
                var start = p * provideNumber // 开始截取的位置
                var end = start + provideNumber // 结束截取的位置
                // 此处特殊处理最后一行的索引值
                if (p == rowNumber - 1) {
                  // 最后一次不换行
                  tempStr = params.substring(start, paramsNameNumber)
                } else {
                  // 每一次拼接字符串并换行
                  tempStr = params.substring(start, end) + '\n'
                }
                newParamsName += tempStr // 最终拼成的字符串
              }
            } else {
              // 将旧标签的值赋给新标签
              newParamsName = params
            }
            //将最终的字符串返回
            return newParamsName
          },
        },

        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        name: '温度 (°C)',
        min: min - 5,
        max: max + 5,
        position: 'left',
        alignTicks: true,
        nameTextStyle: {
          color: '#464646',
          // fontSize: 12,
        },
        // axisLabel: {
        //   formatter: "{value} °C",
        // },
      },
      series: [
        {
          data: [...res.data.data.maxTemp],

          type: 'line',
          lineStyle: {
            width: 1,
            type: '',
          },
          itemStyle: {
            normal: {
              color: '#64bfff', //改变折线点的颜色
              lineStyle: {
                color: '#64bfff', //改变折线颜色
              },
            },
          },
        },
        {
          data: [...res.data.data.minTemp],

          type: 'line',
          lineStyle: {
            width: 1,
            type: '',
          },
          itemStyle: {
            normal: {
              color: '#8bc8a9', //改变折线点的颜色
              lineStyle: {
                color: '#8bc8a9', //改变折线颜色
              },
            },
          },
        },
      ],
    }

    option && myChart.setOption(option)
  }
  // 点击按钮查看大图
  add() {
    if (this.size < 900) {
      this.size = this.size + 50
    } else {
      this.size = 900
    }
  }
  adds() {
    if (this.sizes < 900) {
      this.sizes = this.size + 50
    } else {
      this.sizes = 900
    }
  }
  addes() {
    if (this.sizees < 900) {
      this.sizees = this.size + 50
    } else {
      this.sizees = 900
    }
  }
  htmlToCanvas() {
    this.isDom = (this.$refs as any).imageDom.style.paddingBottom = '30px'
    let that = this
    this.Overlay = true
    this.$dialog.confirm({
      title: '确定将报告生成图片',
      beforeClose(action, done) {
        if (action === 'confirm') {
          done()
          that.Overlay = false
          that.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            loadingType: 'spinner',
          })
          that.toimg()
        } else {
          done()
          that.Overlay = false
          that.isDom = true
        }
      },
    })
  }

  toimg() {
    this.$nextTick(() => {
      setTimeout(() => {
        setTimeout(() => {
          html2canvas((this.$refs as any).imageDom, { scale: 1.9 }).then(
            (canvas) => {
              let imageUrl = canvas.toDataURL('image/png') // 将canvas转成base64图片格式
              this.canvasImageUrl = imageUrl
              this.$router.push({
                path: '/webPng',
                query: { canvasImageUrl: this.canvasImageUrl },
              })
            },
          )
        }, 1000)
      }, 2000)
    })
  }

  mounted() {
    this.titlePagesList()
  }
  titlePagesList() {
    titlePages(this.orederIds).then((res) => {
      if (res.data.code == 1001) {
        this.$toast('非法访问')
        this.$router.go(-1)
      }

      this.project = {
        name: res.data.data.name,
        enterpriseName: res.data.data.enterpriseName,
      }
      console.log(this.project, '测试')
      this.res = res
      this.list = res.data.data.partyOrder
      this.list1 = res.data.data.partyItems
      this.list2 = res.data.data.thirdPartyDiagnoseVo
      this.list3 = res.data.data.partyDetectionResult
      // this.Charts(res);
      this.Polyline(res)
      this.voltage(res)
      this.ceilingVoltage(res)
      this.monomerTemperature(res)
      this.rangetemperature(res)
      this.souh = (100 - this.list2.soh + 0).toFixed(2)
    })
  }
  created() {
    this.orederIds = this.$route.query.orderId
    console.log('获取到订单号：' + this.orederIds)
  }
  @Watch('size')
  getVisible(newVal: any) {
    ;(this as any).$refs.panel.innerHTML =
      '<div class="chart" id="mains" style="height:' +
      newVal +
      'px;width:+' +
      newVal +
      'px" ></div>'
    this.Polyline(this.res)
  }
  @Watch('sizes')
  getVisibles(newVal: any) {
    ;(this.$refs as any).panels.innerHTML =
      '<div class="chart" id="line" style="height:' + newVal + 'px"></div>'
    ;(this.$refs as any).paneles.innerHTML = this.voltage(this.res)
    ;(this.$refs as any).paneles.innerHTML =
      '<div class="chart" id="lines" style="height:' + newVal + 'px"></div>'
    this.ceilingVoltage(this.res)
  }
  @Watch('sizees')
  getVisibles_tq(newVal: any) {
    ;(this.$refs as any).panels_wd.innerHTML =
      '<div class="chart" id="temperature" style="height:' +
      newVal +
      'px"></div>'
    ;(this.$refs as any).paneles_jc.innerHTML = this.monomerTemperature(
      this.res,
    )
    ;(this.$refs as any).paneles_jc.innerHTML =
      '<div class="chart" id="rangetemperature" style="height:' +
      newVal +
      'px"></div>'
    this.rangetemperature(this.res)
  }
}
